module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAALRJREFUOBGtU00LgzAMNbKLhx307Njv83fo1f3HgecNLOjN7j2pYAMpjBpI07yXj5rWwnvfQWfoWRY4fREE+wFK7CzM6QTLjLj7EaxsE/yPwg/X3bCzkhmU4na+5JojlxRYM06w8gSvRIENnE/wo5DETdQwemCbiEyBb2H15zrwXw0y/j9Bdz4SS1oQD4sE3vMhLWhZGW2fAX8b/D5EK9nIieAqewaXFHDRoWKHXJrHELN+5x9WC8b9NjrmPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/btn-dialog.png
// module id = S+Ve
// module chunks = 27